import GenerateReport from './GenerateReport';

export default GenerateReport;
